import React from "react";
import { DataGrid, GridColDef, GridSortModel, GridToolbarFilterButton } from '@mui/x-data-grid';
import { Box, Link, IconButton, Tooltip, LinearProgress } from "@mui/material";
import { EmailReportModuleModel } from "../../models/EmailReportModuleModel";
import { FaRegEdit } from "react-icons/fa";
import { RiExpandUpDownLine } from "react-icons/ri";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

interface Iprops {
    ReportModuleCL: EmailReportModuleModel[],
    fetchData: () => void,
    sortModel: any,
    setSortModel: React.Dispatch<React.SetStateAction<any>>
    loading: boolean,
    setLoading: (loading: boolean) => void,
}


export const EmailReportModuleList: React.FC<Iprops> = ({ ReportModuleCL, fetchData, sortModel, setSortModel, loading, setLoading }) => {
    function EditToolbar() {
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 2, py: 1.5 }}>
            <GridToolbarFilterButton
                sx={{
                    textTransform: 'none',
                    fontWeight: 600,
                    borderColor: '#e2e8f0',
                    color: '#02A4E3',
                    '&:hover': {
                        borderColor: '#2099d2',
                        backgroundColor: '#2099d214',
                        color: '#2099d2',
                    },
                }}
            />
          </Box>
        );
    }

    const columns: GridColDef[] = [


        { field: 'customerName', type: 'text', headerName: 'Client', flex: 0.5,hideSortIcons: true, minWidth: 155,
        renderHeader: (params) => {
          const sortItem = sortModel?.find(
            (item: any) => item.field === 'customerName'
          );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
          <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
          </div>
        )},
        headerAlign: 'left', align: 'left', 
        renderCell: (params) => (
          <Tooltip 
            title={params.row.customerName || 'N/A'}
            arrow
          >
            <span style={{ cursor: 'pointer'}}>
              {params.row.customerName}
            </span>
          </Tooltip>
        ) },
        { field: 'templateName', type: 'text', headerName: 'Template Name', flex: 0.5,hideSortIcons: true, minWidth: 150,
          renderHeader: (params) => {
            const sortItem = sortModel?.find(
              (item: any) => item.field === 'templateName'
            );
        
            const isSortedAsc = sortItem?.sort === 'asc';
            const isSortedDesc = sortItem?.sort === 'desc'
            return (
            <div>
              <span className="table-card-title" >{params.colDef.headerName}</span>
              {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
            </div>
          )}, headerAlign: 'left', align: 'left' },

        {
            field: 'emailSent', type: 'text', headerName: 'Email sent', flex: 0.5,hideSortIcons: true, minWidth: 120,
            renderHeader: (params) => {
              const sortItem = sortModel?.find(
                (item: any) => item.field === 'emailSent'
              );
          
              const isSortedAsc = sortItem?.sort === 'asc';
              const isSortedDesc = sortItem?.sort === 'desc'
              return (
              <div>
                <span className="table-card-title" >{params.colDef.headerName}</span>
                {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
              </div>
            )}, headerAlign: 'left', align: 'left', renderCell: (params) => (
                params.row.emailSent ? "Email sent" : "Email not sent")
        },
        { field: 'emailSendDate', type: 'text', headerName: 'Email Send Date', flex: 0.5,hideSortIcons: true, minWidth: 150,
        renderHeader: (params) => {
          const sortItem = sortModel?.find(
            (item: any) => item.field === 'emailSendDate'
          );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
          <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
          </div>
        )}, headerAlign: 'left', align: 'left' },
        { field: 'mailSentTo', type: 'text', headerName: 'Mail sent to', flex: 0.5,hideSortIcons: true, minWidth: 220,
          renderHeader: (params) => {
            const sortItem = sortModel?.find(
              (item: any) => item.field === 'mailSentTo'
            );
        
            const isSortedAsc = sortItem?.sort === 'asc';
            const isSortedDesc = sortItem?.sort === 'desc'
            return (
            <div>
              <span className="table-card-title" >{params.colDef.headerName}</span>
              {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
            </div>
          )}, headerAlign: 'left', align: 'left',
        renderCell: (params) => (
          <Tooltip 
            title={params.row.mailSentTo || 'N/A'}
            arrow
          >
            <span style={{ cursor: 'pointer'}}>
              {params.row.mailSentTo}
            </span>
          </Tooltip>
        ) },
        {
            field: 'Action', flex: 0.5,hideSortIcons: true, minWidth: 100,
            filterable: false, 
            sortable: false,
            disableColumnMenu: true,
            disableExport: true,
            renderHeader: (params) => (
              <div>
                <span className="table-card-title" >{params.colDef.headerName}</span>
                <RiExpandUpDownLine />
              </div>
            ), headerName: "Action", headerAlign: 'center', align: 'center', renderCell: (params) =>
            (
            <div style={{ display: 'flex', justifyItems: 'center', justifyContent: "center"}}>

                <Link href={'/Reporting/EmailReportModuleDetails/' + params.row?.emailReportId} color="#1976D2">
                    {
                            (<IconButton
                                title="Reporting Detail"
                                sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(32,153,210,0.15) !important' } }}
                            >
                                <Tooltip
                                    title="Reporting Detail"
                                    placement="top"
                                    arrow
                                >
                                    <EditOutlinedIcon fontSize="medium" color="primary" />
                                </Tooltip>
                            </IconButton>)
                    }
                </Link>
            </div>
            )


        },


    ];

    return (
        <div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 1.5,
                    px: { xs: 4, md: 2 },
                    py: 1.5,
                    borderBottom: '1px solid #e2e8f0',
                    backgroundColor: '#fafbfc',
                    minHeight: 70,
                    mb: 3,
                    marginLeft: { xs: '-24px', md: '0px' },
                    marginRight: { xs: '-24px', md: '0px' },
                }}
            >
                <h4 className="mb-0" style={{ fontWeight: 600, color: '#0f172a' }}>
                    Email Reports
                </h4>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0,
                    borderRadius: '12px',
                    overflow: 'hidden',
                    boxShadow: '0 4px 24px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.06)',
                    border: '1px solid #e2e8f0',
                    backgroundColor: '#ffffff',
                    height: 'calc(100vh - 250px)',
                    position: 'relative',
                }}
            >
                {loading && (<>
                  <Box
                    position="absolute"
                    top={0}
                    left={0}
                    right={0}
                    bottom={0}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                        backgroundColor: "rgba(250, 251, 252, 0.85)",
                        zIndex: 10,
                        border: "1px solid #e2e8f0",
                        borderRadius: 1,
                    }}
                >
                    <Box sx={{ width: "100%", maxWidth: 320 }}>
                        <LinearProgress color="info" sx={{ backgroundColor: "#e2e8f0", "& .MuiLinearProgress-bar": { backgroundColor: "#132D3D" } }} />
                        <Box sx={{ mt: 1.5, textAlign: "center" }}>
                            <span style={{ fontSize: "14px", fontWeight: 600, color: "#475569" }}>Loading...</span>
                        </Box>
                    </Box>
                </Box>
                </>)}
                <DataGrid
                    sortModel={sortModel}
                    onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
                    getRowId={(r) => r.emailReportId}
                    rows={ReportModuleCL}
                    columns={columns}
                    pageSize={50}
                    rowsPerPageOptions={[50]}
                    style={{ textAlign: 'center' }}
                    components={{
                        Toolbar: EditToolbar,
                    }}
                    sx={{
                        fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                        border: 'none',
                        fontSize: '14px',
                        color: '#475569',
                        backgroundColor: '#ffffff',
                        '& .MuiDataGrid-columnHeaderTitle': {
                            whiteSpace: 'normal',
                            lineHeight: 1.35,
                            fontWeight: 600,
                            fontSize: '12px',
                            letterSpacing: '0.05em',
                            textTransform: 'uppercase',
                            color: '#64748b',
                        },
                        '& .MuiDataGrid-columnHeaders': {
                            backgroundColor: '#f8fafc',
                            borderBottom: '2px solid #e2e8f0',
                            borderTop: '1px solid #e2e8f0',
                            minHeight: '52px !important',
                            maxHeight: '52px !important',
                        },
                        '& .MuiDataGrid-columnHeader': {
                            '&:focus, &:focus-within': { outline: 'none' },
                        },
                        '& .MuiDataGrid-row': {
                            transition: 'background-color 0.15s ease',
                            '&:nth-of-type(even)': {
                                backgroundColor: '#fafbfc',
                            },
                            '&:hover': {
                                backgroundColor: '#f1f5f9 !important',
                            },
                        },
                        '& .MuiDataGrid-cell': {
                            borderBottom: '1px solid #f1f5f9',
                            fontSize: '14px',
                            color: '#334155',
                            overflow: 'visible',
                            whiteSpace: 'normal',
                            lineHeight: 'normal',
                            wordWrap: 'break-word',
                            textOverflow: 'clip',
                            padding: '8px 16px',
                            '&:focus': { outline: 'none' },
                        },
                        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                            marginBottom: '0px !important',
                        },
                        '& .MuiDataGrid-virtualScroller': {
                            border: 'none',
                        },
                        '& .MuiDataGrid-main': {
                            border: 'none',
                        },
                        '& .MuiDataGrid-footerContainer': {
                            borderTop: '1px solid #e2e8f0',
                            backgroundColor: '#f8fafc',
                            minHeight: 56,
                        },
                        '& .MuiTablePagination-root': {
                            color: '#64748b',
                            fontSize: '13px',
                        },
                        '& .MuiTablePagination-select': {
                            fontSize: '13px',
                            borderRadius: '6px',
                            border: '1px solid #e2e8f0',
                        },
                        '& .MuiIconButton-root': {
                            color: '#64748b',
                            '&:hover': {
                                backgroundColor: '#f1f5f9',
                                color: '#475569',
                            },
                        },
                    }}
                />
            </Box>
        </div>
    );
}


